import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { FromDictionaryPipe } from '@teamfoster/sdk/dictionary-ngrx';
import { Metafield } from 'src/app/shop';
import { RouterLink } from '@angular/router';
import { TitleCasePipe } from '@angular/common';

@Component({
  selector: 'app-product-specifications',
  templateUrl: './product-specifications.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, TitleCasePipe, FromDictionaryPipe],
})
export class ProductSpecificationsComponent {
  private dict = new FromDictionaryPipe();

  @Input() specs: Metafield[] = [];

  printValue(spec: Metafield) {
    if (spec.type === 'boolean') {
      return spec.value === 'true' ? this.dict.transform('ja') : this.dict.transform('nee');
    }
    return spec.value;
  }

  trackByFn(index: number, item: Metafield) {
    return item?.id;
  }
  trackByLinks(index: number, item: { title: string; handle: string }) {
    return item?.handle;
  }
}
